import m from "../../es2015/lang/sv_SE";
window.am4lang_sv_SE = m;


//////////////////
// WEBPACK FOOTER
// ./lang/sv_SE.js
// module id = null
// module chunks = 